import Joyride, { type CallBackProps } from 'react-joyride';
import { joyrideLocale, joyrideStyles } from './joyrideConfig';
import { policyArchiveTourSteps } from './policyArchiveTourSteps';
import { useCompanyPolicyTour } from './useCompanyPolicyTour';

const TOUR_STORAGE_KEY = 'hr-company-policy-archive-tour-completed';

type PolicyArchiveTourProps = {
    run: boolean;
    onCallback: (data: {
        status?: string;
        type?: string;
        index?: number;
    }) => void;
};

export function PolicyArchiveTour({ run, onCallback }: PolicyArchiveTourProps) {
    const handleCallback = (data: CallBackProps) => {
        onCallback({ status: data.status, type: data.type, index: data.index });
    };

    return (
        <Joyride
            steps={policyArchiveTourSteps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={handleCallback}
            locale={joyrideLocale}
            styles={joyrideStyles}
            scrollToFirstStep
            scrollOffset={24}
            scrollDuration={300}
        />
    );
}

export function usePolicyArchiveTour() {
    return useCompanyPolicyTour(TOUR_STORAGE_KEY);
}
